// Shared types + context for the toast system, kept in a non-component
// module so ToastProvider.tsx exports only components (satisfies
// react-refresh/only-export-components).

import { createContext, useContext } from "react";

export type ToastTone = "info" | "success" | "warning" | "danger";

export interface ToastInput {
  title: string;
  description?: string;
  /** Optional request ID; rendered in a mono tail ("· reqID 8f3a…"). */
  requestId?: string;
}

export interface ToastItem extends ToastInput {
  id: string;
  tone: ToastTone;
}

export interface ToastApi {
  info: (t: ToastInput) => void;
  success: (t: ToastInput) => void;
  warning: (t: ToastInput) => void;
  danger: (t: ToastInput) => void;
  dismiss: (id: string) => void;
  /** Clear all toasts — called on route change to prevent stale notifications. */
  clearAll: () => void;
}

export const ToastContext = createContext<ToastApi | undefined>(undefined);

export function useToast(): ToastApi {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used inside <ToastProvider>");
  }
  return ctx;
}
